import GridListTogglePresentation from 'components/GridListToggle/GridListTogglePresentation'

export default {
  Presentation: GridListTogglePresentation,
}
